__turbopack_context__.v({
  "internal_navigation": "_6oXdwq_internal_navigation",
  "modal_page_transition": "_6oXdwq_modal_page_transition",
});
